module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "background": "white"
    }
  }, [_c('div', {
    staticClass: "container platform business-loan"
  }, [_c('div', {
    staticClass: "row business-loan-box invest-with-us"
  }, [_c('div', {
    staticClass: "col-12 col-lg-5 offset-lg-1"
  }, [_c('div', {
    staticClass: "business-loan-box-left-inner"
  }, [_c('h1', [_vm._v("Invest in a worthy cause & proven business")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticStyle: {
      "background-color": "rgb(84, 86, 255)",
      "color": "#ffffff",
      "font-size": "16px",
      "font-weight": "700",
      "height": "53px",
      "width": "169px",
      "border-radius": "26.5px",
      "border": "none"
    },
    on: {
      "click": function($event) {
        this.window.location.href = '/get-start'
      }
    }
  }, [_vm._v("Apply Now")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('br')])]), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "row platform-for-success"
  }, [_c('div', {
    staticClass: "col-10 col-lg-8",
    staticStyle: {
      "background-color": "#f6f9ff"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-2 col-lg-4",
    staticStyle: {
      "background-color": "#00234d"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container platform-for-success-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-10 offset-lg-1"
  }, [_c('h2', {
    staticClass: "text-left"
  }, [_vm._v("Unique opportunities from an underserved market")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "platform-for-success-summary"
  }, [_vm._v("See how we are providing better funding for California small and medium businesses. And find out how it offers opportunities for investors.")]), _vm._v(" "), _c('button', {
    staticClass: "platform-for-success-button",
    on: {
      "click": function($event) {
        this.window.location.href = '/contact-us'
      }
    }
  }, [_vm._v("Contact Us")])])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "background": "white"
    }
  }, [_c('div', {
    staticClass: "container platform how-works"
  }, [_c('h2', {
    staticClass: "text-center"
  }, [_vm._v("Driving growth in business lending")]), _vm._v(" "), _c('p', {
    staticClass: "text-center invest-with-us-text how-works-p"
  }, [_vm._v("American Credit opens new avenues for lending to businesses. Especially those who have passable, but less-than-prime, credit scores and to whom banks won’t loan. We combine local, personal service with advanced data science and financial expertise to assess risk quickly—and to accurately determine the success of a business and ability to repay.")]), _vm._v(" "), _c('h2', {
    staticClass: "text-center",
    staticStyle: {
      "padding-top": "0"
    }
  }, [_vm._v("The result:")]), _vm._v(" "), _c('p', {
    staticClass: "text-center invest-with-us-text how-works-p"
  }, [_vm._v("Fast funding on fair and transparent terms for businesses who need capital. Plus, new opportunities for investors. See how our business lending platform is set to drive growth in the huge and poorly-served business lending market. And discover how its integration of block chain technology, big data analytics and personal service deliver rigorous risk management. Find out more:")]), _vm._v(" "), _c('div', {
    staticClass: "row how-works-button"
  }, [_c('button', {
    staticStyle: {
      "background-color": "rgb(84, 86, 255)",
      "color": "#ffffff",
      "font-size": "16px",
      "font-weight": "700",
      "height": "53px",
      "width": "169px",
      "border-radius": "26.5px",
      "border": "none",
      "margin": "7px"
    },
    on: {
      "click": function($event) {
        this.window.location.href = '/get-start'
      }
    }
  }, [_vm._v("Apply Now")]), _vm._v(" "), _c('button', {
    staticStyle: {
      "background-color": "#ffffff",
      "color": "rgb(84, 86, 255)",
      "font-size": "16px",
      "font-weight": "700",
      "height": "53px",
      "width": "169px",
      "border-radius": "26.5px",
      "border": "1px solid rgb(84, 86, 255)",
      "margin": "7px"
    },
    on: {
      "click": function($event) {
        return this.window.open('https://youtu.be/JH96Q66Y4Hc', '_blank')
      }
    }
  }, [_vm._v("Watch Demo")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "row user-feedback invest-with-us-user-feedback"
  }, [_c('div', {
    staticClass: "col-2 col-lg-4",
    staticStyle: {
      "background-color": "#00234d"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-10 col-lg-8",
    staticStyle: {
      "background-color": "#f6f9ff"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container row user-feedback-content"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-10 offset-2 col-lg-5 offset-lg-0 user-feedback-content-right"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/quote.png"),
      "alt": "American Credit Investor Customer Voice Quote"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "user-feedback-text invest-with-us-feedback"
  }, [_vm._v("The loan officer could see how profitable we are. But even with three great years of business our bank won’t look beyond our credit score.")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "user-feedback-button"
  }, [_c('button', {
    on: {
      "click": function($event) {
        this.window.location.href = 'tel:1855-904-0188'
      }
    }
  }, [_vm._v("Let’s Talk")]), _vm._v(" "), _vm._m(5)])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "background": "white"
    }
  }, [_c('div', {
    staticClass: "container platform trust-us"
  }, [_c('div', {
    staticClass: "row trust-us-box"
  }, [_c('div', {
    staticClass: "col-12 col-lg-5 offset-lg-1 trust-us-inner-left"
  }, [_c('div', [_c('p', {
    staticClass: "trust-us-title"
  }, [_vm._v("American Credit: the difference you can trust")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "trust-us-button"
  }, [_c('button', {
    on: {
      "click": function($event) {
        this.window.location.href = '/get-start'
      }
    }
  }, [_vm._v("Apply Now")]), _vm._v(" "), _vm._m(7)])])]), _vm._v(" "), _vm._m(8)])])]), _vm._v(" "), _vm._m(9)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "font-size": "18px",
      "line-height": "30px",
      "margin-top": "30px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#696969",
      "font-weight": "400"
    }
  }, [_vm._v("Try us now. See how we get you the money fast. ")]), _c('span', {
    staticStyle: {
      "color": "#5456ff",
      "font-weight": "700"
    }
  }, [_c('a', {
    attrs: {
      "href": "/get-start"
    }
  }, [_vm._v("Get Started "), _c('i', {
    staticClass: "fa fa-long-arrow-right"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 col-lg-5 business-loan-box-right"
  }, [_c('img', {
    staticClass: "invest-with-us-main-img",
    attrs: {
      "src": require("../assets/imgs/American_Credit_Investors.png"),
      "alt": "American Credit Investors"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row text-left"
  }, [_c('div', {
    staticClass: "col-12 col-lg-6 pt-2"
  }, [_c('div', {
    staticClass: "platform-for-success-card"
  }, [_c('div', {
    staticClass: "image-container"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/unique_opportunity_1.png"),
      "alt": "American Credit Invest Unique Opportunity 1"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', {
    staticClass: "platform-for-success-title"
  }, [_vm._v("High tech may steal the headlines")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "platform-for-success-text"
  }, [_vm._v("But a recent government report shows small businesses are the single largest drivers of revenue and job growth in California"), _c('sup', [_vm._v("1")]), _vm._v(". Yet the state’s small businesses have poor access to the funds they need to grow, with banks unwilling to loan and other lenders charging unaffordable fees—challenges to which American Credit now offers a solution.")]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-6 pt-2"
  }, [_c('div', {
    staticClass: "platform-for-success-card"
  }, [_c('div', {
    staticClass: "image-container"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/unique_opportunity_2.png"),
      "alt": "American Credit Invest Unique Opportunity 2"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', {
    staticClass: "platform-for-success-title"
  }, [_vm._v("Invest in powering America’s biggest economy")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "platform-for-success-text"
  }, [_vm._v("By first focusing its business lending within California, American Credit immediately addresses an underserved sector with $324 billion in market potential. We have combined deep financial data and risk expertise with partnerships including Experian, Plaid, Ocrolus and IBM to create a smarter, more efficient secured business lending platform.")]), _vm._v(" "), _c('br')])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 col-lg-5 offset-lg-1 user-feedback-content-left"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/American_Credit_Investor_Customer_Voice.png"),
      "alt": "American Credit Investor Customer Voice"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "user-feedback-name"
  }, [_c('span', {
    staticStyle: {
      "color": "#6d6d6d",
      "font-weight": "300"
    }
  }, [_vm._v("David Lee")]), _c('br'), _c('span', {
    staticStyle: {
      "color": "#3c3c3c",
      "font-weight": "700"
    }
  }, [_vm._v("Owner, Beautiful Smile Dental")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#3c3c3c",
      "font-weight": "300"
    }
  }, [_vm._v("Try us now. ")]), _c('span', {
    staticStyle: {
      "color": "#3c3c3c",
      "font-weight": "700"
    }
  }, [_vm._v("See how we get you the money fast. ")]), _c('span', {
    staticStyle: {
      "color": "#5456ff",
      "font-weight": "700"
    }
  }, [_c('a', {
    attrs: {
      "href": "/get-start"
    }
  }, [_vm._v("Get Started "), _c('i', {
    staticClass: "fa fa-long-arrow-right"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "trust-us-text",
    staticStyle: {
      "color": "#686868",
      "font-weight": "300"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v("You work hard. We work hard. We share the same ethic.")]), _vm._v(" That’s why we go the extra mile to look at your situation and see if we can help. Unlike some business credit lenders who focus on FICO scores, we look at your business as a whole.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#3c3c3c",
      "font-weight": "700"
    }
  }, [_c('a', {
    attrs: {
      "href": "contact-us"
    }
  }, [_vm._v("Feel free to contact us "), _c('i', {
    staticClass: "fa fa-long-arrow-right",
    staticStyle: {
      "color": "#5456ff"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 col-lg-5 trust-us-inner-right"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/American_Credit_Business_loans_the_Difference_You_can_Trust.png"),
      "alt": "American Credit Business loans the Difference You can Trust"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "background-color": "white"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-10 offset-lg-1"
  }, [_c('div', {
    staticStyle: {
      "padding-top": "20px",
      "font-family": "Biotif",
      "font-weight": "400",
      "font-size": "14px"
    }
  }, [_vm._v("\n              Footnote\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('ul', {
    staticStyle: {
      "margin": "0",
      "padding-left": "15px"
    }
  }, [_c('li', {
    staticStyle: {
      "list-style": "decimal",
      "font-family": "Biotif",
      "font-weight": "400",
      "font-size": "14px"
    }
  }, [_vm._v("California State Assembly, Small Business Leads California Economic Growth 2019")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2cc2bf06"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/invest.vue
// module id = 1959
// module chunks = 5